import React from 'react'
import { motion } from 'motion/react'
import partner1 from '../../../assets/images/partners/partners1.png'
import partner2 from '../../../assets/images/partners/Picture2.jpg'
import partner3 from '../../../assets/images/partners/Picture3.jpg'
import partner4 from '../../../assets/images/partners/Picture4.jpg'
import partner5 from '../../../assets/images/partners/Picture5.jpg'
import partner6 from '../../../assets/images/partners/Picture6.png'
import partner7 from '../../../assets/images/partners/Picture7.png'
import partner8 from '../../../assets/images/partners/Picture8.png'
import partner9 from '../../../assets/images/partners/Picture9.png'
import partner10 from '../../../assets/images/partners/Picture10.png'
import partner11 from '../../../assets/images/partners/Picture11.jpg'
import partner12 from '../../../assets/images/partners/Picture12.png'
import partner13 from '../../../assets/images/partners/Picture13.jpg'
import partner14 from '../../../assets/images/partners/Picture14.jpg'
import partner15 from '../../../assets/images/partners/Picture15.jpg'
import partner16 from '../../../assets/images/partners/Picture16.jpg'
import partner17 from '../../../assets/images/partners/Picture17.jpg'
import partner18 from '../../../assets/images/partners/Picture18.jpg'
import partner19 from '../../../assets/images/partners/Picture19.jpg'

export default function Partners() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="
        relative mt-24 py-28 px-4 sm:px-6
        bg-gradient-to-b from-sky-50 via-white to-sky-100/40
        overflow-hidden
      "
    >
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-sky-200/30 blur-3xl" />
      <div className="absolute -bottom-40 -left-32 h-96 w-96 rounded-full bg-indigo-200/25 blur-3xl" />

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-3xl font-semibold text-sky-700 mb-2">شركاء الملتقى</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="
            relative
            rounded-[40px]
            border border-sky-100
            bg-white/70 backdrop-blur-xl
            shadow-[0_30px_80px_-35px_rgba(15,23,42,0.35)]
            px-6 py-12 sm:px-12
          "
        >
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-12 border-b border-[#DDD] pb-8 mb-8">
            <h2 className="text-center sm:text-left text-xl sm:text-2xl font-bold leading-tight">
              الجهات
              <br />
              الحكومية
            </h2>

            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-8 gap-y-6">
              {[
                partner7,
                partner8,
              ].map((logo, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 1.1 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{
                    
                    type: 'spring',
                    stiffness: 30,
                    damping: 2,
                  }}
                  whileHover={{ scale: 1.2 }}
                  className="flex items-center justify-center"
                >
                  <img
                    src={logo}
                    alt={`partner-${index + 1}`}
                    className="max-h-16 sm:max-h-18 max-w-[160px] object-contain transition-all duration-300"
                  />
                </motion.div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-12 border-b border-[#DDD] pb-8 mb-8">
            <h2 className="text-center sm:text-left text-xl sm:text-2xl font-bold leading-tight">
              الجهات
              <br />
              الدوليــــة
            </h2>
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-8 gap-y-6">
              {[
                // partner3,
                // partner7,
                
                // partner15,
                partner16,
                partner1,
                partner5,
                partner12,
                partner13,
                partner9,
                partner6,
                partner4,

                
                // partner14,
                // partner18,
                // partner17,
                // partner2,
                // partner11,

                // partner19,
                // partner10,
              ].map((logo, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 1.1 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{
                    
                    type: 'spring',
                    stiffness: 30,
                    damping: 2,
                  }}
                  whileHover={{ scale: 1.2 }}
                  className="flex items-center justify-center"
                >
                  <img
                    src={logo}
                    alt={`partner-${index + 1}`}
                    className="max-h-16 sm:max-h-18 max-w-[160px] object-contain transition-all duration-300"
                  />
                </motion.div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-12 pb-8 mb-8">
            <h2 className="text-center sm:text-left text-xl sm:text-2xl font-bold leading-tight">
              الجهات
              <br />
              المحليـــة
            </h2>
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-8 gap-y-6">
              {[
                partner2,
                partner14,
                partner17,
                // partner18,
                // partner11,

                // partner19,
                // partner10,
              ].map((logo, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 1.1 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{
                    
                    type: 'spring',
                    stiffness: 30,
                    damping: 2,
                  }}
                  whileHover={{ scale: 1.2 }}
                  className="flex items-center justify-center"
                >
                  <img
                    src={logo}
                    alt={`partner-${index + 1}`}
                    className="max-h-16 sm:max-h-18 max-w-[160px] object-contain transition-all duration-300"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  )
}

